<template>
     <div class="category_component">
            <div class="category_title" v-for="category in categories" :key="category.id">
                <router-link :to="{name:'category', params:{ id: category.params}}">
                    {{category.title}}
                </router-link>
                <hr class="category_border">
            </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            categories:[
                {title:"人物",params:"人物",description:"登場人物など"},
                {title:"人体",params:"人体",description:"人体の一部など"},
                {title:"職業",params:"職業",description:"職業・役割など"},
                {title:"動物",params:"動物",description:"動物など"},
                {title:"植物",params:"植物",description:"木・花など"},
                {title:"生物",params:"生物",description:"動物以外"},
                {title:"場所",params:"場所",description:"場所に関係する"},
                {title:"建物",params:"建物",description:"ビルなど建築物"},
                {title:"乗り物",params:"乗り物",description:"人が乗る物全般"},
                {title:"生活",params:"生活",description:"生活必需品など"},
                {title:"道具",params:"道具",description:"道具全般"},
                {title:"衣服",params:"衣服",description:"人が身に付ける物"},
                {title:"スポーツ",params:"スポーツ",description:"スポーツ全般"},
                {title:"楽器",params:"楽器",description:"楽器に関する物"},
                {title:"趣味",params:"趣味",description:"趣味全般"},
                {title:"自然",params:"自然",description:"自然全般"},
                {title:"現象",params:"現象",description:"現象全般"},
                {title:"空想",params:"空想",description:"空想上の存在"},
                {title:"食べ物",params:"食べ物",description:"食べ物全般"},
                {title:"飲み物",params:"飲み物",description:"飲み物全般"},
                {title:"行事",params:"行事",description:"イベント全般"},
                {title:"感情",params:"感情",description:"感情全般"},
                {title:"行動",params:"行動",description:"行動全般"},
            ]
        }
    }
}
</script>

<style scoped>
.category_component{
    margin: 16px 0 16px 16px;
}
.category_title{
    position: relative;
    font-size: 1.1em;
    margin: 8px 0 8px 0; 
}
.category_title::after {
  display: block;
  content: '';
  position: absolute;
  top: .5em;
  left: -1em;
  width: 6px;
  height: 6px;
  border-right: 1px solid #666;
  border-bottom: 1px solid #666;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.category_border{
    margin: 4px;
    border:none;
    border-top:dashed 1px #e8e8e8;
    height:1px;
    color:#FFFFFF;
}
</style>